import { render, staticRenderFns } from "./questionsRight.vue?vue&type=template&id=bf5534fe&scoped=true"
import script from "./questionsRight.vue?vue&type=script&lang=js"
export * from "./questionsRight.vue?vue&type=script&lang=js"
import style0 from "./questionsRight.vue?vue&type=style&index=0&id=bf5534fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5534fe",
  null
  
)

export default component.exports